import Vue from 'vue'

// ------------------------------------------------------------------------------------------------------------------------
// PROTOTYPE 설치
// ------------------------------------------------------------------------------------------------------------------------

import tools from './tools' // tools 설치
Vue.prototype.T = tools

import VueCookie from 'vue-cookie' // https://github.com/alfhen/vue-cookie
// Vue.prototype.$cookie = VueCookie
Vue.use(VueCookie)

import Device from 'mobile-device-detect' // https://github.com/duskload/mobile-device-detect
Vue.prototype.$device = Device

// ------------------------------------------------------------------------------------------------------------------------
// PLUGIN 설치
// ------------------------------------------------------------------------------------------------------------------------

import UI from './ui' // ui 설치
Vue.use(UI)

// axios : Vue.prototype.$http = axios
import axios from 'axios'  // https://github.com/axios/axios
import VueAxios from 'vue-axios' // https://github.com/imcvampire/vue-axios
Vue.use(VueAxios, axios)

// moment -- https://github.com/brockpetrie/vue-moment
import moment from 'moment'
import VueMoment from 'vue-moment'
import 'moment/locale/ko'
Vue.use(VueMoment, { moment })

Vue.filter('moment', function (value, format) {
  if (value === null || value === undefined || format === undefined) return ''
  return format === 'from' ? moment(value).fromNow() : moment(value).format(format)
})

import VueProgressBar from 'vue-progressbar' // progressbar -- https://github.com/hilongjw/vue-progressbar
Vue.use(VueProgressBar, {
  // color: '#bffaf3',
  // color: '#8FFFC7',
  color: '#FA371C',
  failedColor: '#874b4b',
  thickness: '4px',
  // thickness: '30px',
  transition: {
    speed: '0.02s',
    opacity: '1s',
    termination: 100
  },
  autoRevert: true,
  // position: "absolute"
  // location: 'top',
  // inverse: false
})

import VueShortke from 'vue-shortkey' // 단축키 --  https://github.com/iFgR/vue-shortkey/blob/master/README.md
Vue.use(VueShortke)

// import Vuebar from 'vuebar' // 스크롤바 디자인 --  http://github.serafin.io/vuebar/
// Vue.use(Vuebar)

import VModal from 'vue-js-modal' // modal -- https://github.com/euvl/vue-js-modal
// Vue.use(VModal)
// Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false } })
Vue.use(VModal, {
    dynamic: true,  // 다이나믹 모달 사용여부. 반드시 이 방식으로 해야 IE9 에서도 작동한다
    injectModalsContainer: true, // <modals-container /> 를 선언하지 않아도 자동으로 body 안에 <modals-container /> 를 넣어준다.
    // 반드시 이 방식으로 사용해야 하는이유는
    // 모달안의 모달 호출후 다시 모달을 호출할때 이 옵션이 아니면 작동하지 않기 때문이다.
    // ex) sample 의 컴펌 -> 증표 인쇄 컴펌 -> 다시 sample 컴펌 ( 이 방식이 아니면 작동 안함 )
})
// Vue.use(VModal, { dynamic: true })

import Notifications from 'vue-notification' // nodify -- https://github.com/euvl/vue-notification
Vue.use(Notifications)

import VueLodash from 'vue-lodash' // https://www.npmjs.com/package/vue-lodash  https://lodash.com/docs/
Vue.use(VueLodash)

import VueTheMask from 'vue-the-mask' // https://www.npmjs.com/package/vue-the-mask
Vue.use(VueTheMask)

import money from 'v-money' // https://github.com/vuejs-tips/v-money
Vue.use(money, {
  decimal: ',',
  thousands: ',',
  prefix: '',
  suffix: '',
  precision: 0,
  masked: false,
})

import Tooltip from 'vue-directive-tooltip' // https://hekigan.github.io/vue-directive-tooltip/#/globals
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'
Vue.use(Tooltip, {
  delay: 0, // 딜레이를 주게 되면 input 이 가깝게 있는 경우 다른 input으로 이동을 하지 못한다.
            // 물론 딜레이가 없으면 해당 툴팁으로 마우스를 이용하여 툴팁내용 선택 복사를 할수없지만
            // input 으로 이동하지 못하여 못가는 것보다는 낫지 않은가. ?
            // 아니면 상황에 따라 input 이 붙어있으면 delay:0 으로 하고 떨어져 있으면 100정도 주는건 어떨지 고민해보자
  placement: 'auto',
  class: 'tooltip-via',
  triggers: ['hover','focus'],
  offset: 5,
})

import Pagination from "vuejs-uib-pagination" // https://github.com/sant123/vuejs-uib-pagination
Vue.use(Pagination)

import VueMq from 'vue-mq' // https://alligator.io/vuejs/vue-media-queries/
Vue.use(VueMq, {
  breakpoints: {
    mobile: 640,
    desktop: Infinity,
  }
})

// vue-mq 에서 matchmedia 를 사용하는데 IE9 에서 작동하지 않는다. 이것을 작동하게 하기위한 matchmedia polyfill plugin
require('matchmedia-polyfill') // https://github.com/paulirish/matchMedia.js/
require('matchmedia-polyfill/matchMedia.addListener')

import VueHtmlToPaper from 'vue-html-to-paper'; // 사용법 : $htmlToPaper('printMe') // https://github.com/mycurelabs/vue-html-to-paper

const options = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=no',
    'scrollbars=no'
  ],
  styles: [
    '/static/css/fonts/font.css?v=1',
    '/static/css/print/common.css?v=1',
    '/static/css/print/style.css?v=3',
    '/static/css/print/print.css?v=14',
  ]
}

Vue.use(VueHtmlToPaper, options);
// Vue.use(VueHtmlToPaper); // or, using the defaults with no stylesheet

import VueWindowSize from 'vue-window-size' // https://github.com/mya-ake/vue-window-size
// Vue.use(VueWindowSize)
Vue.use(VueWindowSize, { delay: 50 })

// ------------------------------------------------------------------------------------------------------------------------
// GLOBAL COMPONENT 설치
// ------------------------------------------------------------------------------------------------------------------------

import tinymce from 'vue-tinymce-editor' // https://www.npmjs.com/package/vue-tinymce-editor -- 웹에디터
Vue.component('tinymce', tinymce)

import MaskedInput from 'vue-text-mask' // https://www.npmjs.com/package/vue-text-mask
Vue.component('masked-input', MaskedInput)

import VueFriendlyIframe from 'vue-friendly-iframe' // https://www.npmjs.com/package/vue-friendly-iframe
Vue.component('vue-friendly-iframe', VueFriendlyIframe)

import VueUploadComponent from 'vue-upload-component' // https://lian-yue.github.io/vue-upload-component/#/en/documents
Vue.component('file-upload', VueUploadComponent)

// import {Datepicker} from '@livelybone/vue-datepicker' // https://github.com/livelybone/vue-datepicker
// Vue.component('datepicker', Datepicker)
// import 'node_modules/@livelybone/vue-datepicker/lib/css/index.scss'
// import 'node_modules/@livelybone/vue-datepicker/lib/css/index.css'
// import {Datepicker, Timepicker, DatetimePicker} from '@livelybone/vue-datepicker';
// Vue.component('timepicker', Timepicker);
// Vue.component('datetime-picker', DatetimePicker);

// import datepicker from 'vue-date-picker' // https://github.com/8788/vue-date-picker
// Vue.component('datepicker', datepicker)


